import bind from 'memoize-bind';
import React, { Component, createContext } from 'react';

import { LoaderSpinner } from './LoaderSpinner';

export interface LoaderContextValue {
  activate(): void;
  deactivate(): void;
  activeCount: number;
}

export const LoaderContext = createContext<LoaderContextValue>({
  activate: () => undefined,
  deactivate: () => undefined,
  activeCount: 0,
});

interface LoaderProviderState {
  activeCount: number;
}

export class LoaderProvider extends Component<{}, LoaderProviderState> {
  state: LoaderProviderState = {
    activeCount: 0,
  };

  timeout: any = null;

  activate() {
    this.setState((state) => ({
      activeCount: state.activeCount + 1,
    }));
  }

  deactivate() {
    // Do a small timeout to prevent flickering...
    this.timeout = setTimeout(() => {
      this.setState((state) => ({
        activeCount: state.activeCount - 1,
      }));
    }, 200);
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const activeCount = this.state.activeCount;

    return (
      <LoaderContext.Provider
        value={{
          activeCount,
          activate: bind(this.activate, this),
          deactivate: bind(this.deactivate, this),
        }}
      >
        {this.props.children}
        {activeCount > 0 && <LoaderSpinner />}
      </LoaderContext.Provider>
    );
  }
}
